import { render, staticRenderFns } from "./createAlipayDia.vue?vue&type=template&id=a137d996&scoped=true&"
import script from "./createAlipayDia.vue?vue&type=script&lang=js&"
export * from "./createAlipayDia.vue?vue&type=script&lang=js&"
import style0 from "./createAlipayDia.vue?vue&type=style&index=0&id=a137d996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a137d996",
  null
  
)

export default component.exports